<template>
  <div v-if="imageShow">
    <v-img
      v-show="image != null"
      :key="key"
      v-if="showMainImage"
      id="image"
      :src="image.src"
      :max-height="maxHeight"
      :max-width="maxWidth"
      @click="showLarge()"
    />
    <v-skeleton-loader
        v-show="image == null"
        :max-height="maxHeight"
        :max-width="maxWidth"
        type="image"
    ></v-skeleton-loader>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="showDialog"
      :hide-overlay="hideOverlay"
      max-width="70%"
      content-class="image-viewer">

      <v-card>
        <v-toolbar fixed flat>
          <v-row align="center">
            <v-col class="d-none d-sm-block" sm="8" md="8">
              <v-toolbar-title class="text-caption">{{ image.name }}</v-toolbar-title>
            </v-col>

            <!-- Close Button -->
            <v-col cols="2" sm="4" md="4" class="text-right">
              <v-icon
                @click="showDialog = false"
                class="greyBold--text"
              > close
              </v-icon>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <v-img
            id="big-image"
            :src="image.src"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    maxHeight: String,
    maxWidth: String,
    hideOverlay: Boolean,
    showMainImage: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      imageShow: false,
      showDialog: false,
      image: null,
      key: 1
    }
  },
  methods: {
    initViewer(imageData) {
      this.image = imageData;
      this.imageShow = true;
    },
    showLarge() {
      if (this.image && this.image.src) {
        this.showDialog = true;
      }
    },
    reset() {
      this.imageShow = false;
      this.showDialog = false;
      this.image = null;
      this.key++;
    }
  }
}
</script>

<style src="@/modules/core/components/DocumentViewer/ImageViewer.scss" lang="scss"/>